import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import axios from 'axios';
import { saveAs } from 'file-saver'


export default function QRCodeModalAnalytics({ QRCodeDefault, hideQRCodeAnalytics, defaultLink, saveQRCodeAnalytics, name, QRCodePropertiesDefault }) {

    //projectQRCodePropertiesDefault - properties inherited from project to module and activity

    console.log('qr');
    console.log(QRCodeDefault);
    console.log(QRCodePropertiesDefault);

    const defaultWidth =            QRCodePropertiesDefault ? QRCodePropertiesDefault.size : 300;
    const defaultColor =            QRCodePropertiesDefault ? QRCodePropertiesDefault.color : '#541D94';
    const defaultBackgroundColor =  QRCodePropertiesDefault ? QRCodePropertiesDefault.background : '#ffffff';

	const [link, setLink] = useState(defaultLink || '');
    const [width, setWidth] = useState(defaultWidth);
    const [color, setColor] = useState(defaultColor);
    const [backgroundColor, setBackgroundColor] = useState(defaultBackgroundColor);

    const handleChange = e => {
        setLink(e.target.value);
    }

    const handleColorChange = e => {
        setColor(e.target.value);
    }

    const handleBgColorChange = e => {
        setBackgroundColor(e.target.value);
    }

    const handleWidthChange = e => {
        setWidth(e.target.value);
    }

    const handleDownload = () => {

        //saveQRCodeAnalytics(QRCode);

        //qrCode.download({ extension: "png" });
    }

    const handleSave = () => {

        //saveQRCodeAnalytics(QRCode);

        hideQRCodeAnalytics();
    }

    //=====================================

    const [QRCode, setQRCode] = useState(QRCodeDefault);

	const createQr = () => {

        console.log('create');

		const url = 'https://lagoon-qr-tracker.james-0cc.workers.dev/create_qr';
		const data = {
			link: link,
			color: color,
			background: backgroundColor,
			size: width,
			name: name,
		}
		console.log(data);


		axios.post(url, data).then((res) => {

//          console.log(res.data.id);
//          console.log(res.data.png);
// 			console.log(res.data.svg);

            let result = {
                link: link,
                color: color,
                background: backgroundColor,
                size: width,
                id: res.data.id,
                png: res.data.png,
                svg: res.data.svg,
            }

			setQRCode(result);
            saveQRCodeAnalytics(result);

		}).catch((e) => {

			console.log(e);

		});


	}

	const updateQr = () => {

        console.log('update');

		const url = 'https://lagoon-qr-tracker.james-0cc.workers.dev/update_qr';
		const data = {
			link: link,
			color: color,
			background: backgroundColor,
			size: width,
			name: name,
            id: QRCode.id
		}
		console.log(data);


		axios.post(url, data).then((res) => {

            //console.log(res.data.id);
            //console.log(res.data.png);
			//console.log(res.data.svg);

            let result = {
                link: link,
                color: color,
                background: backgroundColor,
                size: width,
                id: res.data.id,
                png: res.data.png,
                svg: res.data.svg,
            }

			setQRCode(result);
            saveQRCodeAnalytics(result);

		}).catch((e) => {

			console.log(e);

		});


	}

/*
	useEffect(() => {

        console.log('change qr props');

        if ((!QRCode) || (

            width != defaultWidth
            ||
            link != defaultLink
            ||
            color != defaultColor
            ||
            backgroundColor != defaultBackgroundColor

        )){
            if (!QRCode)
                createQr();
            else
                updateQr();
        }

    }, [link, color, backgroundColor, width]);
*/



    const handleGenerate = () => {

        createQr();
//      hideQRCodeAnalytics();
    }

    function slug(value) {
        return value == undefined ? '' : value.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
    }

    const download = async () => {

        if (QRCode.png){
            console.log(QRCode.svg);

            let data = {
                link: QRCode.svg,
            };
            const url = 'https://lagoon-qr-tracker.james-0cc.workers.dev/get_image';



            axios.post(url, data).then((res) => {

                const file = new Blob([res.data], {type:'image/svg'})
                console.log(file.size) // !!! this line
                console.log(file);

                //let blob = res.data.blob();
                saveAs(file, 'QR '+slug(name)+'.svg');

            }).catch((e) => {

                console.log(e);

            });
        }
    }

    return (
        <div className="wrapper qr_analytics">
            <div className="modal">
                <div className="header">
                    <h2>Generate QR Code</h2>
                    <div className="cancel" onClick={hideQRCodeAnalytics}>
                        <Cancel />
                        Close
                    </div>
                </div>


                <div className="qr-form">

                    {!QRCode &&

                        <div>
                            <label className="label">Input for QR Code</label>
                            <input
                                type="text"
                                value={link}
                                onChange={handleChange}
                            />

                            <label className="label">Color</label>
                            <input
                                type="color"
                                value={color}
                                onChange={handleColorChange}
                            />

                            <label className="label">Background Color</label>
                            <input
                                type="color"
                                value={backgroundColor}
                                onChange={handleBgColorChange}
                            />

                            <label className="label">Width</label>
                            <input
                                type="number"
                                value={width}
                                onChange={handleWidthChange}
                            />

                        </div>

                    }

                    <div>

                        <div className="qr-code-container">

                            {/* <div dangerouslySetInnerHTML={QRCode.svg && {__html: QRCode.svg }}></div> */}

                            {QRCode && QRCode.png &&
                                <img src={QRCode.png} />
                            }

                        </div>

                    </div>
                </div>

                <div className="button-container">

                    {!QRCode &&

                        <button className="button" onClick={handleGenerate}>Generate</button>
                    }

                     {QRCode && QRCode.png &&

                        <>
                            <button className="button" onClick={download}>
                                download
                            </button>

                        </>

                    }

                    <button className="button" onClick={hideQRCodeAnalytics}>Close</button>

                    {/*
                        <button className="button" onClick={handleSave}>Save</button>
                    */}




                </div>
            </div>
        </div>
    )

}
